'use client';

import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';

import { ApiSchemas } from '@/components/providers/v1-api';

type ApiOrg = ApiSchemas['OrganizationRead'];

export const ADMIN_ORG_COLUMNS: ColumnDef<ApiOrg>[] = [
  {
    header: 'Name',
    accessorKey: 'name',
  },
  {
    header: 'Status',
    accessorKey: 'status',
    cell: ({ row }) => {
      return <span className='capitalize'>{row.original.status.toLowerCase()}</span>;
    },
  },
  {
    header: 'Created At',
    accessorKey: 'created_at',
    cell: ({ row }) => {
      return <span>{format(row.original.created_at, 'MM/dd/yyyy')}</span>;
    },
  },
];
